<div class="flex flex-row flex-wrap justify-content-center pt-8">
    <div class="surface-card p-4 shadow-2 border-round w-full lg:w-6">
        <div class="text-center mb-5">
            <div class="text-900 text-3xl font-medium mb-3">Sign up new account</div>
        </div>

        <div class="flex w-full justify-content-center">
            <p-button (onClick)="signUp()" label="Sign up"></p-button>
        </div>
    </div>
</div>
